/* Yuvakart — Liquid Glass motion (Motion One, the engine behind Framer Motion)
   · spring hover on glass surfaces
   · smoothed specular highlight (lerped, not jumpy)
   · magnetic CTAs
   · spring entrance for the sticky bar
   · Buy Now forced red (beats #id !important rules) */
import { animate, spring, inView, stagger } from 'https://cdn.jsdelivr.net/npm/@motionone/dom@10.18.0/+esm';

(function(){
  var BUY = '#c0392b', BUY_DK = '#a12f23';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  var GLASS = [
    '.yk-glass','.pp__main','.pp__ai','.pp__offer','.pp__revsec','.pp__trust div','.pp__inc label',
    '[id^="ykc-"] .ykc__row','[id^="ykc-"] .ykc__summary',
    '[id^="ykw-"] .ykw__card',
    '[id^="ykp-"] .ykp__card','[id^="ykp-"] .ykp__stat','[id^="ykp-"] .ykp__gate',
    '[id^="yka2-"] .yka2__panel','[id^="ykg-"] .ykg__card','.ts__panel','.bl__feat'
  ].join(',');

  /* ---------- Buy Now -> red ---------- */
  function paintBuy(){
    var nodes = document.querySelectorAll(
      '.shopify-payment-button__button,.shopify-payment-button__button--unbranded,' +
      '.pp__dyn button,.shopify-payment-button button'
    );
    nodes.forEach(function(b){
      if(b.dataset.buyred) return;
      b.dataset.buyred = '1';
      b.style.setProperty('background', BUY, 'important');
      b.style.setProperty('background-image', 'none', 'important');
      b.style.setProperty('color', '#ffffff', 'important');
      b.style.setProperty('border-color', BUY, 'important');
      b.style.setProperty('box-shadow', '0 12px 26px -10px rgba(192,57,43,.75), inset 0 1px 0 rgba(255,255,255,.28)', 'important');
      b.addEventListener('mouseenter', function(){ b.style.setProperty('background', BUY_DK, 'important'); });
      b.addEventListener('mouseleave', function(){ b.style.setProperty('background', BUY, 'important'); });
    });
    document.querySelectorAll('shopify-accelerated-checkout,shopify-accelerated-checkout-cart').forEach(function(el){
      var r = el.shadowRoot;
      if(!r || r.querySelector('style[data-buyred]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-buyred','1');
      st.textContent = 'button,.shopify-payment-button__button{background:' + BUY + ' !important;background-image:none !important;color:#fff !important;}';
      try{ r.appendChild(st); }catch(e){}
    });
  }

  /* ---------- smoothed specular + spring lift ---------- */
  function bindGlass(){
    if(!fine || reduce) return;
    document.querySelectorAll(GLASS).forEach(function(el){
      if(el.dataset.glass) return;
      el.dataset.glass = '1';

      var tx = 50, ty = 50, cx = 50, cy = 50, raf = null;
      function loop(){
        cx += (tx - cx) * 0.16;
        cy += (ty - cy) * 0.16;
        el.style.setProperty('--gx', cx.toFixed(2) + '%');
        el.style.setProperty('--gy', cy.toFixed(2) + '%');
        if(Math.abs(tx - cx) > .3 || Math.abs(ty - cy) > .3){ raf = requestAnimationFrame(loop); }
        else { raf = null; }
      }

      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        if(!r.width) return;
        tx = ((e.clientX - r.left) / r.width) * 100;
        ty = ((e.clientY - r.top) / r.height) * 100;
        if(!raf) raf = requestAnimationFrame(loop);
      }, {passive:true});

      el.addEventListener('mouseenter', function(){
        animate(el, { '--gop': 1 }, { duration:.45, easing:[.22,1,.36,1] });
        animate(el, { transform:'translateY(-3px)' }, { easing: spring({ stiffness:220, damping:20 }) });
      });
      el.addEventListener('mouseleave', function(){
        tx = 50; ty = 50;
        if(!raf) raf = requestAnimationFrame(loop);
        animate(el, { '--gop': .45 }, { duration:.6, easing:[.22,1,.36,1] });
        animate(el, { transform:'none' }, { easing: spring({ stiffness:200, damping:22 }) });
      });
    });
  }

  /* ---------- magnetic CTAs ---------- */
  function bindMagnetic(){
    if(!fine || reduce) return;
    document.querySelectorAll('.yks__b,.pp__atc,.pp__dyn .shopify-payment-button__button').forEach(function(b){
      if(b.dataset.mag) return;
      b.dataset.mag = '1';
      b.addEventListener('mousemove', function(e){
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width/2) * .16;
        var y = (e.clientY - r.top - r.height/2) * .30;
        animate(b, { transform:'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)' }, { duration:.2 });
      }, {passive:true});
      b.addEventListener('mouseleave', function(){
        animate(b, { transform:'none' }, { easing: spring({ stiffness:320, damping:17 }) });
      });
    });
  }

  /* ---------- sticky bar: spring in when it appears ---------- */
  function bindSticky(){
    var bar = document.querySelector('.pp__sticky');
    if(!bar || bar.dataset.motion) return;
    bar.dataset.motion = '1';
    if(reduce) return;
    var wasShown = false;
    new MutationObserver(function(){
      var shown = bar.classList.contains('show');
      if(shown && !wasShown){
        animate(bar, { transform:['translateY(100%)','translateY(0)'] },
          { easing: spring({ stiffness:260, damping:26 }) });
        var kids = bar.querySelectorAll('.yks__img,.yks__info,.yks__b');
        if(kids.length){
          animate(kids, { opacity:[0,1], transform:['translateY(10px)','none'] },
            { delay: stagger(.05, { start:.08 }), duration:.5, easing:[.22,1,.36,1] });
        }
      }
      wasShown = shown;
    }).observe(bar, { attributes:true, attributeFilter:['class'] });
  }

  /* ---------- glass panels rise into view ---------- */
  function bindReveal(){
    if(reduce) return;
    try{
      inView(GLASS, function(info){
        var el = info.target;
        if(el.dataset.revealed) return;
        el.dataset.revealed = '1';
        animate(el, { opacity:[0,1], transform:['translateY(16px) scale(.995)','none'] },
          { duration:.7, easing:[.22,1,.36,1] });
      }, { amount:.12 });
    }catch(e){}
  }

  function run(){ paintBuy(); bindGlass(); bindMagnetic(); bindSticky(); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ run(); bindReveal(); }); }
  else { run(); bindReveal(); }
  addEventListener('load', run);
  setTimeout(run, 600); setTimeout(run, 1600); setTimeout(run, 3000);
  try{
    var t = null;
    new MutationObserver(function(){
      if(t) return;
      t = setTimeout(function(){ t = null; run(); }, 300);
    }).observe(document.body, { childList:true, subtree:true });
  }catch(e){}
})();